import React, { Component } from 'react'

import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import withTour from '../../../../../../components/hocs/withTour'
import LottieLoader from '../../../../../../components/ui/lotties/LottieLoader'
import selectors from '../../../../../../store/shared/selectors'
import sendFullStoryEvent from '../../../../../../utils/analyticsHelpers/sendFullStoryEvent'
import fullstory from '../../../../../../utils/constants/fullstory'
import withSearch360CareerProfiles from '../../../../../../utils/graphql/hocs/withSearch360CareerProfiles'
import intercom from '../../../../../../utils/intercom/intercomUtils'
import ListViewPath from '../Pathways/ListViewPath'
import WheelZoomChart from '../WheelZoomChart'

class Career extends Component {
  static propTypes = {
    careerPathsWheelData: PropTypes.any.isRequired,
    careerPaths: PropTypes.array.isRequired,
    isMobile: PropTypes.bool.isRequired,
    onChangeResultsPage: PropTypes.func.isRequired,
    loadingCareersData: PropTypes.bool.isRequired,
    getCareerPaths: PropTypes.func.isRequired,
  }

  constructor() {
    super()

    this.onChangeActiveIndex = nextIndex => this.setState({ activeIndex: nextIndex })

    this.state = {
      activeIndex: 0,
    }
  }

  componentWillMount() {
    this.props.onChangeResultsPage('educationPage3')
  }

  componentDidMount() {
    this.props.getCareerPaths(this.props.searchFormValues)
  }

  render() {
    const { careerPathsWheelData, careerPaths, isMobile, loadingCareerPaths } = this.props
    const { activeIndex } = this.state

    if (loadingCareerPaths) {
      return (
        <LottieLoader
          height={300}
          width={300}
          isReady={!loadingCareerPaths}
          animationName="GEARS"
          loadingTime={5000}
          isMobile={isMobile}
        />
      )
    }

    return (
      <div className="card shadow">
        <div style={{ marginBottom: 10 }}>
          <h4 className="text-center mt-3 mb-0">
            {activeIndex === 0 ? 'Career Path Mapping' : 'Career Wheel'}
          </h4>
          <h6 className="text-center mb-2">
            {activeIndex === 0 ? 'click for info' : 'scroll to zoom | click for info'}
          </h6>
        </div>
        <div className="btn-group" style={{ width: '80%', marginLeft: '10%' }} id="wheelToggle">
          <button
            onClick={() => {
              this.setState({ activeIndex: 0 })
              const eventProperties = {
                view_str: 'Career Path Mapping',
              }
              sendFullStoryEvent(fullstory.eventNames.exploreCareers, eventProperties)
            }}
            className={`btn ${activeIndex === 0 ? 'btn-primary' : 'btn-outline-secondary'}`}
            style={{ width: '50%' }}
          >
            List View
          </button>
          <button
            onClick={() => {
              this.setState({ activeIndex: 1 })
              intercom.intercomEvent('wheelchart_open')
              const eventProperties = {
                view_str: 'Career Wheel',
              }
              sendFullStoryEvent(fullstory.eventNames.exploreCareers, eventProperties)
            }}
            className={`btn ${activeIndex === 1 ? 'btn-primary' : 'btn-outline-secondary'}`}
            style={{ width: '50%' }}
          >
            Wheel View
          </button>
        </div>
        <br />
        <div id="careerPaths">
          {activeIndex === 0 ? (
            <ListViewPath careerPaths={careerPaths} isMobile={isMobile} />
          ) : (
            <WheelZoomChart chartData={careerPathsWheelData} />
          )}
        </div>
      </div>
    )
  }
}

const educationPage3 = [
  {
    selector: '#wheelToggle',
    content: 'Use the toggle to switch how you interact with our data',
  },
  {
    selector: '#careerPaths',
    content: 'Click on the circles to see details. Scroll to see more.',
  },
  {
    selector: '#search360Tabs',
    content: "Click other tabs here when you're ready for more",
  },
]

const mapStateToProps = () => {
  const getFormValues = selectors.makeGetFormValues()
  return state => ({
    searchFormValues: getFormValues(state.form.careerSearchForm),
  })
}

export default withTour(
  'educationPage3',
  educationPage3,
)(connect(mapStateToProps)(withSearch360CareerProfiles(Career)))



// WEBPACK FOOTER //
// ./src/routes/authenticated/Search/routes/components/CareerPaths/Career.js